window.global = window;
import('./bootstrap');
